import { render, staticRenderFns } from "./PageAuth.vue?vue&type=template&id=057b5a58&"
import script from "./PageAuth.vue?vue&type=script&lang=js&"
export * from "./PageAuth.vue?vue&type=script&lang=js&"
import style0 from "./PageAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports